import { render, staticRenderFns } from "./starguide.vue?vue&type=template&id=3b1334e3&scoped=true"
import script from "./starguide.vue?vue&type=script&lang=js"
export * from "./starguide.vue?vue&type=script&lang=js"
import style0 from "./starguide.vue?vue&type=style&index=0&id=3b1334e3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1334e3",
  null
  
)

export default component.exports